import axios from "axios";

export default {
  state: {
    stampanti: [],
    print_jobs: [],
  },
  getters: {
    get_stampanti: (state) => state.stampanti,
    get_print_jobs: (state) => state.print_jobs,
  },
  mutations: {
    set_stampanti(state, data) {
      state.stampanti = data;
    },
    set_print_jobs(state, data) {
      state.print_jobs = data;
    },
  },
  actions: {
    fetch_stampanti(context) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/admin/zebra/devices";
        let auth = context.getters.get_credential;
        axios
          .get(url, { auth })
          .then((res) => {
            context.commit("set_stampanti", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_print_jobs(context, { from } = {}) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/admin/zebra/jobs";
        let auth = context.getters.get_credential;
        const params = from ? { from } : {};
        axios
          .get(url, { auth, params })
          .then((res) => {
            context.commit("set_print_jobs", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    patch_stampante(context, { id_device, params }) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/admin/zebra/devices/" + id_device;
        let auth = context.getters.get_credential;
        axios
          .patch(url, params, { auth })
          .then((res) => {
            context.commit(
              "set_stampanti",
              context.state.stampanti.map((s) =>
                s.device_id === id_device ? { ...s, ...res.data } : s
              )
            );
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    purge_print_jobs(context, { before, state } = {}) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/admin/zebra/jobs/purge";
        let auth = context.getters.get_credential;
        const params = { before };
        if (state) params.state = state;
        axios
          .delete(url, { auth, params })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    associa_coltura_lotto(context, payload) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/admin/lotti/associa_coltura";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload, { auth })
          .then((res) => resolve(res.data))
          .catch((err) => reject(err));
      });
    },
    invia_stampa_lotto(context, payload) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/admin/zebra/jobs";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload, { auth })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
